import { makeStyles } from 'tss-react/mui';
import { colors, theme } from '../../../theme';

/**
 * useNotificationsPageStyles defines the styles for the NotificationsPage component.
 */
const useNotificationComponentStyles = makeStyles()(() => ({
  notificationText: {
    marginTop: '0.25rem',
    marginBottom: '0.5em',
  },
  notificationMeta: {
    color: colors.gray[300],
  },
  notificationIcon: {
    marginRight: '30px',
    marginLeft: '10px',
    display: 'flex',
    alignItems: 'center',
  },
  linkStyle: {
    'cursor': 'pointer',
    'color': theme.primary.light,
    'textDecoration': 'none',
    '&:hover': {
      color: theme.primary.dark,
    },
    '&:active': {
      color: theme.primary.darker,
    },
  },
  notification: {
    display: 'flex',
    flexDirection: 'row',
    boxShadow: theme.containerShadow,
    fontFamily: theme.fontFamily,
    cursor: 'pointer',
    margin: theme.margin.m,
    borderRadius: theme.borderRadius.s,
    padding: theme.padding.m,
    backgroundColor: theme.background.paper,
  },
}));

export default useNotificationComponentStyles;
